export default __webpack_public_path__ + "static/white-logo-dccd21e2154e0874e060a1a4361dcd2b.svg";